import * as Yup from 'yup'

export const contactSchema = (t, step) => {
  return Yup.object().shape({
    fullName: Yup.string().required(t('form.required')),
    phoneNumber: Yup.string().required(t('form.required')),
    workEmail: Yup.string()
      .required(t('form.required'))
      .email(t('form.invalidEmail'))
      .test({
        message: t('form.invalidEmail'),
        test: (email) => {
          if (!email) {
            return false
          }

          return true
          // const invalidDomains = [
          //   'gmail.com',
          //   'hotmail.com',
          //   'yahoo.com',
          //   'yahoo.in',
          //   'msn.com',
          //   'live.com',
          //   'outlook.com',
          //   'microsoft.com',
          //   'zoho.com',
          //   'rediff.com',
          //   'edu.vn',
          // ]

          // const emailDomain = email.split('@')[1]
          // return !invalidDomains.includes(emailDomain)
        },
      }),
    enterpriseName: Yup.string().required(t('form.required')),
    otp:
      step == 1
        ? Yup.string().optional()
        : Yup.string().required(t('form.required')),
    area: Yup.string().nullable().required(t('form.required')),
    currentRole: Yup.string().nullable().required(t('form.required')),
    workType: Yup.string().nullable().required(t('form.required')),
    interestFeature: Yup.string().nullable().required(t('form.required')),
    experientalPurpose: Yup.string().nullable().required(t('form.required')),
    // currentRole: Yup.array().test({
    //   message: t('form.required'),
    //   test: (arr) => arr.length !== 0,
    // }),
    // workType: Yup.array().test({
    //   message: t('form.required'),
    //   test: (arr) => arr.length !== 0,
    // }),
    // interestFeature: Yup.array().test({
    //   message: t('form.required'),
    //   test: (arr) => arr.length !== 0,
    // }),
    // experientalPurpose: Yup.array().test({
    //   message: t('form.required'),
    //   test: (arr) => arr.length !== 0,
    // }),
  })
}
